const player = require("play-sound")()

const upSFX = () => player.play("./assets/up.mp3")
const downSFX = () => player.play("./assets/down.mp3")

export { upSFX, downSFX }
